import { RouteConfig } from '../../types/routing.types';
import { Shield } from 'lucide-react';
import OrganisationDashboard from './components/OrganisationDashboard';
import SiteManagement from './components/sites/SiteManagement';
import EmployeeManagement from './components/employees/EmployeeManagement';
import DepartmentManagement from './components/departments/DepartmentManagement';
import RoleManagement from './components/roles/RoleManagement';
import PositionManagement from './components/positions/PositionManagement';
import CompetenceManagement from './components/competences/CompetenceManagement';
import AdvancedHierarchyManagement from './components/hierarchy/AdvancedHierarchyManagement';
import OrganigrammeView from './components/organigramme/OrganigrammeView';
import OrgChartCacheManagement from './components/cache/OrgChartCacheManagement';

export const organisationRoutes: RouteConfig[] = [
  {
    path: '/organisation',
    component: OrganisationDashboard,
    label: 'Organisation',
    icon: Shield,
    showInNav: true,
    breadcrumb: ['Accueil', 'Organisation'],
  },
  {
    path: '/organisation/sites',
    component: SiteManagement,
    label: 'Sites',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Sites'],
  },
  {
    path: '/organisation/employees',
    component: EmployeeManagement,
    label: 'Employés',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Employés'],
  },
  {
    path: '/organisation/departments',
    component: DepartmentManagement,
    label: 'Départements',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Départements'],
  },
  {
    path: '/organisation/roles',
    component: RoleManagement,
    label: 'Rôles QHSE',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Rôles QHSE'],
  },
  {
    path: '/organisation/positions',
    component: PositionManagement,
    label: 'Postes',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Postes'],
  },
  {
    path: '/organisation/competences',
    component: CompetenceManagement,
    label: 'Compétences',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Compétences'],
  },
  {
    path: '/organisation/hierarchy',
    component: AdvancedHierarchyManagement,
    label: 'Hiérarchie',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Hiérarchie'],
  },
  {
    path: '/organisation/organigramme',
    component: OrganigrammeView,
    label: 'Organigramme',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Organigramme'],
  },
  {
    path: '/organisation/cache',
    component: OrgChartCacheManagement,
    label: 'Cache',
    icon: Shield,
    showInNav: false,
    breadcrumb: ['Accueil', 'Organisation', 'Cache'],
  },
];
